import React from 'react'
import { useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import DriveSidebar from 'components/layout/DriveSidebar'
import Panel, { PanelSpacer, PanelTitle } from 'components/layout/Panel'
import Page from 'rui/widgets/Page'
import { Icon } from 'roadie-ui'
import OnboardingCard from './OnboardingCard'
import { useLocalization, LocalizedText } from 'localization'

const BlocksOnboardingPage: React.FC = () => {
  const { t } = useLocalization()
  const isWebview = useSelector<any, boolean>((state) => state.config.isWebview)

  return (
    <Page sidebar={<DriveSidebar />}>
      <Helmet>
        <title>{t('dweb_blocks_onboarding_about_scheduled_blocks')}</title>
      </Helmet>
      {!isWebview && (
        <PanelTitle>
          <LocalizedText translationKey="dweb_blocks_onboarding_about_scheduled_blocks" />
        </PanelTitle>
      )}
      <Panel left noPadding>
        <OnboardingCard
          icon={<Icon.InfoOutline />}
          iconColor="secondary-dark"
          iconBackgroundColor="info-lighter"
          title={t('dweb_blocks_onboarding_what_scheduled_blocks')}
          description={t('dweb_blocks_onboarding_learn_about_blocks')}
          link={`${import.meta.env.REACT_APP_SUPPORT_URL}/support/s/article/What-are-Scheduled-Blocks`}
        />
      </Panel>
      {isWebview && <PanelSpacer />}
      <Panel left noPadding>
        <OnboardingCard
          icon={<Icon.Person />}
          iconColor="primary-dark"
          iconBackgroundColor="primary-lighter"
          title={t('dweb_blocks_onboarding_driver_requirements')}
          description={t('dweb_blocks_onboarding_understand_eligibility_requirements')}
          link={`${
            import.meta.env.REACT_APP_SUPPORT_URL
          }/support/s/article/How-to-be-eligible-for-RoadieXD-Scheduled-Blocks`}
        />
      </Panel>
      {isWebview && <PanelSpacer />}
      <Panel left noPadding>
        <OnboardingCard
          icon={<Icon.VehicleCar />}
          iconColor="alert-dark"
          iconBackgroundColor="alert-lighter"
          title={t('dweb_blocks_onboarding_completing_first_block')}
          description={t('dweb_blocks_onboarding_learn_sign_up_accept_block_gigs')}
          link={`${
            import.meta.env.REACT_APP_SUPPORT_URL
          }/support/s/article/A-step-by-step-guide-to-your-first-Scheduled-Block`}
        />
      </Panel>
      {isWebview && <PanelSpacer />}
      <Panel left noPadding>
        <OnboardingCard
          icon={<Icon.PhoneDollarSign />}
          iconColor="success-dark"
          iconBackgroundColor="success-lighter"
          title={t('dweb_blocks_onboarding_earnings_payments')}
          description={t('dweb_blocks_onboarding_account_specific_issues_questions')}
          link={`${
            import.meta.env.REACT_APP_SUPPORT_URL
          }/support/s/article/Earnings-and-Payments-for-RoadieXD-Scheduled-Blocks`}
        />
      </Panel>
      {isWebview && <PanelSpacer />}
      <Panel left noPadding>
        <OnboardingCard
          icon={<Icon.QuestionMarkCircle />}
          iconColor="primary-dark"
          iconBackgroundColor="primary-lighter"
          title={t('dweb_dashboard_account_status_faqs')}
          description={t('dweb_blocks_onboarding_account_specific_issues_questions')}
          link={`${import.meta.env.REACT_APP_SUPPORT_URL}/support/s/article/RoadieXD-Scheduled-Blocks-FAQs`}
        />
      </Panel>
    </Page>
  )
}

export default BlocksOnboardingPage
